import axios from 'axios';
import posthog from 'posthog-js';

const state = {
  errorBit: false,
  errorInfo: "",
};

const mutations = {
  SET_ERROR_BIT: (state, errorBit) => {
    state.errorBit = errorBit;
  },
  SET_ERROR_INFO: (state, errorInfo) => {
    state.errorInfo = errorInfo;
  },
};

const getters = {
  errorBit: (state) => state.errorBit,
  errorInfo: (state) => state.errorInfo,
};

const errorHandler = {
  state,
  getters,
  mutations,

  // Log error details with stack trace and performance stats
  logError(type, error) {
    let performance = window.performance;

    /*console.log(`Error Type: ${type}`);
    console.log('Error:', error);
    console.log('Stack Trace:', error.stack);
    console.log('Error payload:', error.requestPayload);
    //console.log('Memory Usage:', `${(performance.memory.usedJSHeapSize / 1048576).toFixed(2)} MB / ${(performance.memory.jsHeapSizeLimit / 1048576).toFixed(2)} MB`);
    console.log('Client Info:', {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      language: navigator.language
    });*/

    //state.errorBit = true;
    //state.errorInfo = "Error details...";

    /*throw new Error(
        "<br>" +
        "Server responded with error = True <br> errorCode: "
    );*/
  },

  install(Vue, store) {
    // Add axios to Vue prototype
    //console.log("Installing custom error logger...");
    // Add axios request interceptor
    axios.interceptors.request.use((config) => {
      // Attach request payload to the config
      config.metadata = { startTime: new Date(), payload: config.data }; // Logging start time, and the initial request data.
      return config;
    });

    // Add axios response interceptor
    axios.interceptors.response.use((response) => {
      // Check for "error" flag in the response data

      const endTime = new Date();
      const duration = endTime - response.config.metadata.startTime;
      // Attach request payload to the response
      //response.requestPayload = response.config.metadata.payload;

      if (response.data && response.data.error) {
        const error = new Error(response.data.errorCode || 'An error occurred');
        //error.requestPayload = response.requestPayload;
        error.duration = duration;
        // Tag the rejection so callers can tell a soft API error apart from a real
        // exception. err.stack is not a reliable carrier: it omits the message entirely
        // in Firefox/Safari, so any caller .catch() that commits err.stack destroys the
        // errorCode the error dialogs branch on (see SET_ERROR_INFO below and the guard
        // in company-list-module.js).
        error.errorCode = response.data.errorCode || 'unknown';
        error.softApiError = true;

        this.logError('HTTP Error', error);
        // Feed soft API errors into PostHog error tracking (same sink as the Vue
        // errorHandler in main.js) -- these are business-level failures the transport
        // layer can't see (HTTP 200 with error:true in the body), and before this they
        // were invisible to any tooling. posthog-js queues safely if init hasn't run.
        posthog.captureException(error, {
          soft_api_error: true,
          errorCode: response.data.errorCode || 'unknown',
          endpoint: response.config.url,
          duration_ms: duration,
        });
        // Rejecting here means this response never reaches a caller's own .then()
        // branch, only .catch()/.finally(). Most call sites only have .then()/.finally()
        // (no .catch()), so without this fallback, soft "error: true" API responses were
        // silently swallowed with no user-facing message at all -- surface it globally
        // via the error store so <error-handler /> can show something regardless of
        // whether the calling code handles the rejection itself.
        if (store) {
          store.commit('SET_ERROR_BIT', true);
          store.commit(
            'SET_ERROR_INFO',
            '<br>Server responded with error = True <br> errorCode: ' +
              (response.data.errorCode || 'unknown') +
              '<br> ' + response.config.url + ' <br>'
          );
        }
        return Promise.reject(error);
      }

      return response;
    }, (error) => {
      if (error.config) {
        error.requestPayload = error.config;
      }
      this.logError('HTTP Error', error);
      // Transport-level failures (timeouts, 5xx, DNS) into PostHog too.
      posthog.captureException(error, {
        transport_error: true,
        endpoint: error.config ? error.config.url : 'unknown',
        status: error.response ? error.response.status : null,
      });
      return Promise.reject(error);
    });

    // Add Vue error handler
    Vue.config.errorHandler = (error, vm, info) => {
      //this.logError('Vue Error', error);
      //console.log('Vue error info:', info);
    };

    // Add window error listener
    window.addEventListener('error', (event) => {
      //this.logError('Global Error', event.error);
    });
  }
};

export default errorHandler;
